// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Layout_wrap__3Y4cM"};